query allTennisPlayers(
  $first: Int
  $offset: Int
  $filter: TennisPlayerWithTeamFilter
  $condition: TennisPlayerWithTeamCondition
) {
  players: allTennisPlayerWithTeams(
    first: $first
    offset: $offset
    filter: $filter
    condition: $condition
  ) {
    nodes {
      teams
      player {
        name
        source
        playerIndex
        playerId
      }
    }
    totalCount
  }
}
